<div id="app-communitysd" class="container d-flex flex-column flex-grow-1 mt-5 pt-4 pb-4 h-100" role="main"
  [attr.aria-label]="('COMMUNITY' | translate)">
  <app-headline [type]="'h4'" [class]="'text-muted fw-bold mb-2'" [title]="('COMMUNITY' | translate)"></app-headline>
  <ng-container *ngIf="!(loadingService.loadingIndicator$ | async)">
    <div class="card mb-3">
      <div class="card-body p-0">
        <div class="card border-0 box-shadow-bottom">
          <div class="card-body text-center p-4">
            <div class="my-3">
              <div
                class="no-content-large-icon bg-warning rounded-circle d-flex justify-content-center align-items-center mx-auto">
                <app-icon-badge [style]="'noContent'" [icon]="'forum'"></app-icon-badge>
              </div>
              <app-headline [type]="'h5'" [class]="'card-title mt-3'"
                [title]="'COMMUNITYNOCOMMUNITIES' | translate"></app-headline>
            </div>

            <div
              class="fade-card d-flex align-items-center gap-2 p-2 mt-5 rounded-3 shadow-sm bg-light border flex-wrap">
              <app-icon-badge [style]="'default'" [icon]="'forum'" [fontSize]="'fs-5'"
                [fontColor]="'text-warning'"></app-icon-badge>
              <div class="d-flex flex-column text-start flex-grow-1">
                <app-headline [type]="'h6'" [class]="'fw-bold text-muted'"
                  [title]="'COMMUNITYCREATECOMMUNITYTITLE' | translate"></app-headline>
                <app-content [fontSize]="'fs-default'">{{ 'COMMUNITYSTARTYOURFIRSTCOMMUNITYNOW' | translate
                  }}</app-content>
              </div>
              <div class="d-flex justify-content-end w-only-sm-100">
                <app-form-button [text]="'START' | translate" (click)="onOpenDialog($event, 'show-newcommunitydialog')"
                  [cssClass]="'e-primary fw-semibold'"></app-form-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="card mb-3">
    <div class="card-body">
      <!-- Search Bar -->
      <div class="d-flex align-items-center gap-2">
        <div class="flex-grow-1">
          <app-form-input [type]="'search'" [hasErrorField]="false"
            [placeholder]="('COMMUNITYSSEARCHPLACEHOLDER' | translate)" [iconFront]="'search'" [iconBack]="'close'"
            [iconClickType]="'back'" [fCN]="'searchString'" [fG]="communityForm"></app-form-input>
        </div>
        <app-form-dropdown [fG]="communityForm" [fCN]="'search_filter'" [dataSource]="searchFilterOptions"
          [placeholder]="'SELECTFILTER' | translate" [icon]="''" [popupWidth]="'auto'">
        </app-form-dropdown>
      </div>
      <!-- No search result text -->
      <div class="pt-1">
        <app-headline [title]="('NOSEARCHRESULTS' | translate)" [type]="'h6'"
          [class]="'text-center text-secondary'"></app-headline>
      </div>
      <!-- Result text -->
      <div class="d-flex align-items-center gap-1 pt-3">
        <app-headline [title]="'25'" [type]="'h6'" [class]="'text-secondary fw-bold'"></app-headline>
        <app-headline [title]="'results for your search'" [type]="'h6'" [class]="'text-secondary'"></app-headline>
      </div>
    </div>
  </div>

  <div class="custom-scrollbar overflow-y-auto mb-2">
    <div class="card mb-3">
      <div class="card-body p-3">
        <div class="d-flex flex-column">
          <div class="fade-card d-flex align-items-center gap-2 p-2 mt-3 rounded-3 shadow-sm bg-light border flex-wrap">
            <app-icon-badge [style]="'default'" [icon]="'forum'" [fontSize]="'fs-5'"
              [fontColor]="'text-warning'"></app-icon-badge>
            <div class="d-flex flex-column text-start flex-grow-1">
              <app-headline [type]="'h6'" [class]="'fw-bold text-muted'"
                [title]="'COMMUNITYCREATECOMMUNITYTITLE' | translate"></app-headline>
              <app-content [fontSize]="'fs-default'">{{ 'COMMUNITYSTARTANEWCOMMUNITYDESCRIPTION' | translate
                }}</app-content>
            </div>
            <div class="d-flex justify-content-end w-only-sm-100">
              <app-form-button [text]="'START' | translate" (click)="onOpenDialog($event, 'show-newcommunitydialog')"
                [cssClass]="'e-primary fw-semibold'"></app-form-button>
            </div>
          </div>
          <div class="d-flex align-items-center gap-2 justify-content-end my-3">
            <app-headline [title]="('COMMUNITYVIEWFILTER' | translate)" [type]="'h6'"
              [class]="'fs-small text-default fw-bold'"></app-headline>
            <app-form-dropdown [fG]="communityForm" [fCN]="'display_filter'" [dataSource]="displayFilterOptions"
              [placeholder]="'SELECTFILTER' | translate" [icon]="'filter_list'" [popupWidth]="'auto'"
              [cssClass]="'small-filter-dropdown'">
            </app-form-dropdown>
          </div>
          <!-- SUBCSRIUBED TOPICS SECTION-->
          <div class="d-flex flex-column  my-3">
            <div class="d-flex flex-column gap-3">
              <app-headline [title]="'COMMUNITYSUBSCRIBEDTOPICSTITLE'" [type]="'h6'"
                [class]="'text-primary fw-bold'"></app-headline>
              <div class="d-flex align-items-center flex-wrap gap-2">
                <!-- Remove e-outline from the one selected -->
                <app-form-button [text]="'Show all'" (click)="true" [cssClass]="'e-primary fw-semibold align-middle'"
                  [iconClass]="'fs-5'"></app-form-button>
                <app-form-button [text]="'Sports'" (click)="true"
                  [cssClass]="'e-outline e-primary fw-semibold align-middle'" [iconClass]="'fs-5'"></app-form-button>
                <app-form-button [text]="'Food and life'" (click)="true"
                  [cssClass]="'e-outline e-primary fw-semibold align-middle'" [iconClass]="'fs-5'"></app-form-button>
                <app-form-button [text]="'Buy and sell'" (click)="true"
                  [cssClass]="'e-outline e-primary fw-semibold align-middle'" [iconClass]="'fs-5'"></app-form-button>
              </div>
            </div>
            <!-- TOPIC TILES CONTAINRE -->
            <div class="topic-tiles d-flex flex-wrap gap-2 justify-content-start align-items-stretch mt-3">

              <!-- Unread -->
              <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer unread">
                <div class="card-body p-0">
                  <!-- Image with icon -->
                  <div class="position-relative">
                    <ng-container *ngIf="imageSrc; else noImage">
                      <div class="card-img">
                        <img [src]="imageSrc" alt="icon" class="me-2 w-100 h-100 object-fit-cover rounded-top"
                          appNgSrcImageError>
                      </div>
                    </ng-container>
                    <ng-template #noImage>
                      <div class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                        <div class="icon-placeholder border">
                          <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                      </div>
                    </ng-template>
                    <div class="position-absolute top-0 end-0 p-2">
                      <div
                        class="bg-white bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center dropdown">
                        <div data-bs-toggle="dropdown" aria-expanded="false"
                          [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                          <div class="icon-fix">
                            <app-icon-badge [style]="'default'" [icon]="'more_vert'" [fontColor]="'text-primary'"
                              [fontSize]="'fs-5'"></app-icon-badge>
                          </div>
                        </div>
                        <ul class="dropdown-menu dropdown-menu-end">
                          <li><app-link (click)="onOpenDialog($event, 'show-topicnotifications')"
                              [title]="('COMMUNITYTOPICNOTIFICATIONSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                              ('COMMUNITYTOPICNOTIFICATIONSETTINGSMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYTOPICMARKDISCUSSIONASREADMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYTOPICMARKDISCUSSIONASREADMENU' | translate) }} - if has
                              unread discussion</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYTOPICUNSUBSCRIBEMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYTOPICUNSUBSCRIBEMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYTOPICEDITTOPICMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYTOPICEDITTOPICMENU' | translate) }} - if
                              owner</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYTOPICDELETETOPICMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYTOPICDELETETOPICMENU' | translate) }} - if
                              owner</app-link></li>
                        </ul>
                      </div>
                    </div>
                    <div
                      class="position-absolute bottom-0 end-0 m-2 bg-white bg-opacity-75 text-primary px-2 py-0 rounded d-flex align-items-center gap-1">
                      <span class="mts-icon notranslate fs-6" translate="no">person</span>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'">256</app-content>
                    </div>
                  </div>
                  <div class="d-flex flex-column p-3">
                    <!-- Parent Community Name -->
                    <div class="d-flex">
                      <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'" [truncateLines]="1"
                        [fontDecoration]="'fw-bold'">Parent Community Name</app-content>
                    </div>
                    <!-- Title -->
                    <div class="d-flex jusify-content-start mt-1">
                      <app-headline [title]="'New hire request which goes max two lines and not more'" [type]="'h6'"
                        [class]="'fw-bold truncate-text-two-lines'"></app-headline>
                    </div>
                    <!-- Description -->
                    <div class="d-flex flex-grow-1 jusify-content-start mt-2">
                      <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [truncateLines]="3">Evaluate
                        management efficiency by completing this survey, lorem ipsum dolor. Evaluate management
                        efficiency by completing this survey, lorem ipsum dolor.</app-content>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Normal -->
              <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer">
                <div class="card-body p-0">
                  <!-- Image with icon -->
                  <div class="position-relative">
                    <ng-container *ngIf="false; else noImage">
                      <div class="card-img">
                        <img [src]="imageSrc" alt="icon" class="me-2 w-100 h-100 object-fit-cover rounded-top"
                          appNgSrcImageError>
                      </div>
                    </ng-container>
                    <ng-template #noImage>
                      <div class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                        <div class="icon-placeholder border">
                          <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                      </div>
                    </ng-template>
                    <div class="position-absolute top-0 end-0 p-2">
                      <div
                        class="bg-white bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center dropdown">
                        <div data-bs-toggle="dropdown" aria-expanded="false"
                          [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                          <div class="icon-fix">
                            <app-icon-badge [style]="'default'" [icon]="'more_vert'" [fontColor]="'text-primary'"
                              [fontSize]="'fs-5'"></app-icon-badge>
                          </div>
                        </div>
                        <ul class="dropdown-menu dropdown-menu-end">
                          <li><app-link (click)="onOpenDialog($event, 'show-topicnotifications')"
                              [title]="('COMMUNITYTOPICNOTIFICATIONSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                              ('COMMUNITYTOPICNOTIFICATIONSETTINGSMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYTOPICMARKDISCUSSIONASREADMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYTOPICMARKDISCUSSIONASREADMENU' | translate) }} - if has
                              unread discussion</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYTOPICUNSUBSCRIBEMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYTOPICUNSUBSCRIBEMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYTOPICEDITTOPICMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYTOPICEDITTOPICMENU' | translate) }} - if
                              owner</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYTOPICDELETETOPICMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYTOPICDELETETOPICMENU' | translate) }} - if
                              owner</app-link></li>
                        </ul>
                      </div>
                    </div>
                    <div
                      class="position-absolute bottom-0 end-0 m-2 bg-white bg-opacity-75 text-primary px-2 py-0 rounded d-flex align-items-center gap-1">
                      <span class="mts-icon notranslate fs-6" translate="no">person</span>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'">256</app-content>
                    </div>
                  </div>
                  <div class="d-flex flex-column p-3">
                    <!-- Parent Community Name -->
                    <div class="d-flex">
                      <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'" [truncateLines]="1"
                        [fontDecoration]="'fw-bold'">Parent Community Name</app-content>
                    </div>
                    <!-- Title -->
                    <div class="d-flex jusify-content-start mt-1">
                      <app-headline [title]="'New hire request which goes max two lines and not more'" [type]="'h6'"
                        [class]="'fw-bold truncate-text-two-lines'"></app-headline>
                    </div>
                    <!-- Description -->
                    <div class="d-flex flex-grow-1 jusify-content-start mt-2">
                      <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [truncateLines]="3">Evaluate
                        management efficiency by completing this survey, lorem ipsum dolor. Evaluate management
                        efficiency by completing this survey, lorem ipsum dolor.</app-content>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TRANDING TOPICS SECTION-->
          <div class="d-flex flex-column  my-3">
            <div class="d-flex">
              <app-headline [title]="'COMMUNITYTRANDINGTOPICSTITLE'" [type]="'h6'"
                [class]="'text-primary fw-bold'"></app-headline>
            </div>
            <!-- TILES FOR TRANDING TOPIC CONTAINER - SAME AS TOPIC TILES BUT HAS A BUTTON TO SUBSCRIBE ON THE RIGHT AND NO OPTIONS -->
            <div class="topic-tiles d-flex flex-wrap gap-2 justify-content-start align-items-stretch mt-3">
              <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer ">
                <div class="card-body p-0">
                  <!-- Image with icon -->
                  <div class="position-relative">
                    <ng-container *ngIf="imageSrc; else noImage">
                      <div class="card-img">
                        <img [src]="imageSrc" alt="icon" class="me-2 w-100 h-100 object-fit-cover rounded-top"
                          appNgSrcImageError>
                      </div>
                    </ng-container>
                    <ng-template #noImage>
                      <div class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                        <div class="icon-placeholder border">
                          <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                      </div>
                    </ng-template>
                    <div
                      class="position-absolute bottom-0 end-0 m-2 bg-white bg-opacity-75 text-primary px-2 py-0 rounded d-flex align-items-center gap-1">
                      <span class="mts-icon notranslate fs-6" translate="no">person</span>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'">256</app-content>
                    </div>
                    <div class="position-absolute bottom-0 start-0 m-2 d-flex align-items-center gap-1">
                      <app-form-button (click)="true" [style]="'e-btn'" [text]="'COMMUNITYSUBSCRIBETOPIC' | translate"
                        [cssClass]="'btn-link bg-bright-yellow brd-transparent text-primary fs-default p-1'"
                        [iconClass]="'text-primary'" [icon]="'lock_open'" [iconPosition]="'left'"></app-form-button>
                    </div>
                  </div>
                  <div class="d-flex flex-column p-3">
                    <!-- Parent Community Name -->
                    <div class="d-flex">
                      <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'" [truncateLines]="1"
                        [fontDecoration]="'fw-bold'">Parent Community Name</app-content>
                    </div>
                    <!-- Title -->
                    <div class="d-flex jusify-content-start mt-1">
                      <app-headline [title]="'New hire request which goes max two lines and not more'" [type]="'h6'"
                        [class]="'fw-bold truncate-text-two-lines'"></app-headline>
                    </div>
                    <!-- Description -->
                    <div class="d-flex flex-grow-1 jusify-content-start mt-2">
                      <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [truncateLines]="3">Evaluate
                        management efficiency by completing this survey, lorem ipsum dolor. Evaluate management
                        efficiency by completing this survey, lorem ipsum dolor.</app-content>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer">
                <div class="card-body p-0">
                  <!-- Image with icon -->
                  <div class="position-relative">
                    <ng-container *ngIf="false; else noImage">
                      <div class="card-img">
                        <img [src]="imageSrc" alt="icon" class="me-2 w-100 h-100 object-fit-cover rounded-top"
                          appNgSrcImageError>
                      </div>
                    </ng-container>
                    <ng-template #noImage>
                      <div class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                        <div class="icon-placeholder border">
                          <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                      </div>
                    </ng-template>
                    <div
                      class="position-absolute bottom-0 end-0 m-2 bg-white bg-opacity-75 text-primary px-2 py-0 rounded d-flex align-items-center gap-1">
                      <span class="mts-icon notranslate fs-6" translate="no">person</span>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'">256</app-content>
                    </div>
                    <div class="position-absolute bottom-0 start-0 m-2 d-flex align-items-center gap-1">
                      <app-form-button (click)="true" [style]="'e-btn'" [text]="'COMMUNITYSUBSCRIBETOPIC' | translate"
                        [cssClass]="'btn-link bg-bright-yellow brd-transparent text-primary fs-default p-1'"
                        [iconClass]="'text-primary'" [icon]="'lock_open'" [iconPosition]="'left'"></app-form-button>
                    </div>
                  </div>
                  <div class="d-flex flex-column p-3">
                    <!-- Parent Community Name -->
                    <div class="d-flex">
                      <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'" [truncateLines]="1"
                        [fontDecoration]="'fw-bold'">Parent Community Name</app-content>
                    </div>
                    <!-- Title -->
                    <div class="d-flex jusify-content-start mt-1">
                      <app-headline [title]="'New hire request which goes max two lines and not more'" [type]="'h6'"
                        [class]="'fw-bold truncate-text-two-lines'"></app-headline>
                    </div>
                    <!-- Description -->
                    <div class="d-flex flex-grow-1 jusify-content-start mt-2">
                      <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [truncateLines]="3">Evaluate
                        management efficiency by completing this survey, lorem ipsum dolor. Evaluate management
                        efficiency by completing this survey, lorem ipsum dolor.</app-content>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- AVAILABLE COMMUNITIES SECTION-->
          <div class="d-flex flex-column  my-3">
            <div class="d-flex">
              <app-headline [title]="'COMMUNITYAVAILABLECOMMUNITIESTITLE'" [type]="'h6'"
                [class]="'text-primary fw-bold'"></app-headline>
            </div>
            <!-- TILES FOR AVAILABLE COMMUNITIES CONTAINER -->
            <div class="community-tiles d-flex flex-wrap gap-2 justify-content-start align-items-stretch mt-3">

              <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer ">
                <div class="card-body p-0">
                  <!-- Image with icon -->
                  <div class="position-relative">
                    <ng-container *ngIf="imageSrc; else noImage">
                      <div class="card-img">
                        <img [src]="imageSrc" alt="icon" class="me-2 w-100 h-100 object-fit-cover rounded-top"
                          appNgSrcImageError>
                      </div>
                    </ng-container>
                    <ng-template #noImage>
                      <div class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                        <div class="icon-placeholder border">
                          <app-icon-badge [style]="'default'" [icon]="'forum'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                      </div>
                    </ng-template>
                    <div class="position-absolute top-0 end-0 p-2">
                      <div
                        class="bg-white bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center dropdown">
                        <div data-bs-toggle="dropdown" aria-expanded="false"
                          [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                          <div class="icon-fix">
                            <app-icon-badge [style]="'default'" [icon]="'more_vert'" [fontColor]="'text-primary'"
                              [fontSize]="'fs-5'"></app-icon-badge>
                          </div>
                        </div>
                        <ul class="dropdown-menu dropdown-menu-end">
                          <li><app-link (click)="true" [title]="('COMMUNITYEDITCOMMUNITYMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYEDITCOMMUNITYMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYMANAGEEDITORSMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYMANAGEEDITORSMENU' | translate)}} - opens the Create
                              Community->Editor Permissions Step</app-link></li>
                          <!--if no Topic under it the menu is missing-->
                          <li><app-link (click)="onOpenDialog($event, 'show-manageWritersTopicList')"
                              [title]="('COMMUNITYMANAGEWRITERSMENU' | translate)" [style]="'dropdown'">{{
                              ('COMMUNITYMANAGEWRITERSMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYMANAGESUBSCRIBERSMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYMANAGESUBSCRIBERSMENU' | translate) }} - opens the
                              Create Community->Subscriber Permissions Step</app-link></li>
                          <li><app-link (click)="onOpenDialog($event, 'show-relocateCommunityList')"
                              [title]="('COMMUNITYREPARENTCOMMUNITYMENU' | translate)" [style]="'dropdown'">{{
                              ('COMMUNITYREPARENTCOMMUNITYMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYDELETECOMMUNITYMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYDELETECOMMUNITYMENU' | translate) }}</app-link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column p-3">
                    <!-- Title -->
                    <div class="d-flex justify-content-center align-items-center mt-1">
                      <app-headline [title]="'Sports'" [type]="'h6'"
                        [class]="'fw-bold text-center truncate-text-two-lines'"></app-headline>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer">
                <div class="card-body p-0">
                  <!-- Image with icon -->
                  <div class="position-relative">
                    <ng-container *ngIf="false; else noImage1">
                      <div class="card-img">
                        <img [src]="imageSrc" alt="icon" class="me-2 w-100 h-100 object-fit-cover rounded-top"
                          appNgSrcImageError>
                      </div>
                    </ng-container>
                    <ng-template #noImage1>
                      <div class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                        <div class="icon-placeholder border">
                          <app-icon-badge [style]="'default'" [icon]="'forum'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                      </div>
                    </ng-template>
                    <div class="position-absolute top-0 end-0 p-2">
                      <div
                        class="bg-white bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center dropdown">
                        <div data-bs-toggle="dropdown" aria-expanded="false"
                          [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                          <div class="icon-fix">
                            <app-icon-badge [style]="'default'" [icon]="'more_vert'" [fontColor]="'text-primary'"
                              [fontSize]="'fs-5'"></app-icon-badge>
                          </div>
                        </div>
                        <ul class="dropdown-menu dropdown-menu-end">
                          <li><app-link (click)="true" [title]="('COMMUNITYEDITCOMMUNITYMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYEDITCOMMUNITYMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYMANAGEEDITORSMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYMANAGEEDITORSMENU' | translate)}} - opens the Create
                              Community->Editor Permissions Step</app-link></li>
                          <!--if no Topic under it the menu is missing-->
                          <li><app-link (click)="onOpenDialog($event, 'show-manageWritersTopicList')"
                              [title]="('COMMUNITYMANAGEWRITERSMENU' | translate)" [style]="'dropdown'">{{
                              ('COMMUNITYMANAGEWRITERSMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYMANAGESUBSCRIBERSMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYMANAGESUBSCRIBERSMENU' | translate) }} - opens the
                              Create Community->Subscriber Permissions Step</app-link></li>
                          <li><app-link (click)="onOpenDialog($event, 'show-relocateCommunityList')"
                              [title]="('COMMUNITYREPARENTCOMMUNITYMENU' | translate)" [style]="'dropdown'">{{
                              ('COMMUNITYREPARENTCOMMUNITYMENU' | translate) }}</app-link></li>
                          <li><app-link (click)="true" [title]="('COMMUNITYDELETECOMMUNITYMENU' | translate)"
                              [style]="'dropdown'">{{ ('COMMUNITYDELETECOMMUNITYMENU' | translate) }}</app-link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column p-3">
                    <!-- Title -->
                    <div class="d-flex justify-content-center align-items-center mt-1">
                      <app-headline [title]="'Food and life'" [type]="'h6'"
                        [class]="'fw-bold text-center truncate-text-two-lines'"></app-headline>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dialogs">
    <!-- Dialog For Topic Notifications -->
    <ejs-dialog target=".dialogs" class="autoheight-dialog" #topicNotifications [visible]='false'
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="onClose('show-topicnotifications')">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('COMMUNITYTOPICNOTIFICATIONS' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('COMMUNITYTOPICNOTIFICATIONSHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="d-flex flex-column h-100 p-3">
          <div class="custom-scrollbar overflow-y-auto">
            <app-form-label [label]="'COMMUNITYTOPICNOTIFICATIONLABEL' | translate"></app-form-label>
            <div class="row mb-2">
              <div class="col-12">
                <app-form-radio [fG]="communityForm" [fCN]="'topic_notifications'" [value]="'all'"
                  [placeholder]="'COMMUNITYTOPICNOTIFICATIONSALLACTIVITYCHECKBOXLABEL' | translate"
                  [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <app-form-radio [fG]="communityForm" [fCN]="'topic_notifications'" [value]="'new'"
                  [placeholder]="'COMMUNITYTOPICNOTIFICATIONSNEWDISCUSSIONSCHECKBOXLABEL' | translate"
                  [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <app-form-radio [fG]="communityForm" [fCN]="'topic_notifications'" [value]="'replies'"
                  [placeholder]="'COMMUNITYTOPICNOTIFICATIONSREPLIESTOMYDISCUSSIONSCHECKBOXLABEL' | translate"
                  [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <app-form-radio [fG]="communityForm" [fCN]="'topic_notifications'" [value]="'mutes'"
                  [placeholder]="'COMMUNITYTOPICNOTIFICATIONSMUTESCHECKBOXLABEL' | translate"
                  [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
              </div>
            </div>
            <app-form-label [label]="'COMMUNITYTOPICNOTIFICATIONSSENDBYLABEL' | translate"></app-form-label>
            <div class="row mb-2">
              <div class="col-12">
                <app-form-checkbox [fCN]="'topic_notifications_bymail'" [fG]="communityForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'COMMUNITYTOPICNOTIFICATIONSBYMAILLABEL'"></app-form-checkbox>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <app-form-checkbox [fCN]="'topic_notifications_bypush'" [fG]="communityForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'COMMUNITYTOPICNOTIFICATIONSBYPUSHLABEL'"></app-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="true"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog Create New Community -->
    <ejs-dialog target=".dialogs" class="steps-dialog" [visible]='false' #createNewCommunityDialog
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="false">
      <ng-template #header class="p-1">
        <app-step-header [steps]="steps" [(activeStep)]="activeStep"></app-step-header>
      </ng-template>
      <ng-template #content>
        <div class="d-flex h-100">
          <!-- Left Column -->
          <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
            <div class="text-center mb-4 pt-m">
              <app-headline [title]="'COMMUNITYCREATENEWTITLE' | translate" [type]="'h5'"></app-headline>
            </div>
            <app-step-content [steps]="steps" [(activeStep)]="activeStep"></app-step-content>
            <div class="save-button-container text-center mt-3 d-none d-md-block">
              <app-form-button [text]="'COMMUNITYCREATE' | translate" [disabled]="communityForm.invalid" (click)="true"
                [cssClass]="'e-primary w-100'"></app-form-button>
            </div>
          </div>

          <!-- Right Column -->
          <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center">
                <app-headline [title]="steps[activeStep]" [type]="'h5'"></app-headline>
                <app-headline *ngIf="activeStep === 3" [title]="'('+('OPTIONALLABEL' | translate) +')'" [type]="'h6'"
                  [class]="'text-success ms-1'"></app-headline>
                <div class="ms-2">
                  <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('COMMUNITYCREATENEWHELP' | translate)"
                    [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'"
                    [opensOn]="'Click'"></app-tooltip>
                </div>
              </div>
              <app-form-button [style]="'btn'" (click)="onClose('show-newcommunitydialog')"
                [cssClass]="'btn-close'"></app-form-button>
            </div>

            <div class="custom-scrollbar overflow-y-auto">
              <form class="p-1 d-flex flex-column h-100">
                <ng-container [ngSwitch]="activeStep">
                  <ng-container *ngSwitchCase="0">
                    <app-form-label [label]="'COMMUNITYTITLELABEL' | translate" [maxChars]="35"
                      [currentChars]="communityForm.controls['community_title'].value.length"></app-form-label>
                    <app-form-input [placeholder]="('COMMUNITYTITLEPLACEHOLDER' | translate)"
                      [label]="('COMMUNITYTITLEPLACEHOLDER' | translate)"
                      [errorText]="('COMMUNITYTITLEREQUIRED' | translate)" [fCN]="'community_title'"
                      [fG]="communityForm" [maxChars]="35"></app-form-input>
                  </ng-container>
                  <ng-container *ngSwitchCase="1">
                    SINGLE IMAGE UPLOAD
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    User/Group selector
                  </ng-container>
                  <ng-container *ngSwitchCase="3">
                    <app-form-label [label]="'COMMUNITYVISIBILITYLABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-12">
                        <!--Opened - Anyone in the organization can see it. Selected users below will be subscribed automatically-->
                        <app-form-radio [fG]="communityForm" [fCN]="'community_visibility'" [value]="0"
                          [placeholder]="'COMMUNITYOPENEDRADIOLABEL' | translate"
                          [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <!--Closed - Only users selected below will be automatically subscribed-->
                        <app-form-radio [fG]="communityForm" [fCN]="'community_visibility'" [value]="1"
                          [placeholder]="'COMMUNITYCLOSEDRADIOLABEL' | translate"
                          [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                      </div>
                    </div>
                    <app-form-label [label]="'COMMUNITYTOPICSUBSCRIBERSLABEL' | translate"></app-form-label>
                    User/Group selector with external email
                  </ng-container>
                </ng-container>
              </form>
            </div>
          </div>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog for Manage Writers -->
    <ejs-dialog target=".dialogs" class="simple-dialog" [visible]='false' #manageWritersTopicList
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' #showEventParticipantsDialog
      [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'"
      [height]="'60vh'" [zIndex]="999" [showCloseIcon]="true">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('COMMUNITYMANAGERWRITERSTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('COMMUNITYMANAGERWRITERSHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="d-flex flex-column h-100 p-3">
          <app-form-input [placeholder]="('COMMUNITYSEARCHTOPICNAME' | translate)" [iconFront]="'search'"
            [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'search_topic_name'"
            [fG]="communityForm"></app-form-input>
          <h6 class="text-center text-secondary">Topic could not be found!</h6>
          <!-- SCrollable content-->
          <div class="custom-scrollbar overflow-y-auto">
            <div class="card topic-card d-flex align-items-center mb-2 cursor-pointer"
              (click)="onOpenDialog($event, 'show-manageWriters')">
              <div class="d-flex align-items-stretch w-100">
                <div class="d-flex align-items-center p-2 me-1">
                  <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                    [fontColor]="'text-muted'"></app-icon-badge>
                </div>

                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                  <div class="d-flex flex-column p-1">
                    <app-headline [type]="'h6'" [title]="'Nature Enthusiasts'"
                      [class]="'text-muted fs-default'"></app-headline>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">Wildlife
                      Photography</app-content>
                  </div>
                </div>

                <div class="d-flex align-items-center pe-2">
                  <app-tooltip [text]="('COMMUNITYMANAGERWRITERSTOOLTIP' | translate)" [opensOn]="'Auto'">
                    <app-form-button (click)="onOpenDialog($event, 'show-manageWriters')" [text]="''"
                      [cssClass]="'e-btn e-flat fs-default text-muted p-1'" [icon]="'person'"
                      [iconClass]="'fs-4 m-1'"></app-form-button>
                  </app-tooltip>
                </div>
              </div>
            </div>

            <div class="card topic-card d-flex align-items-center mb-2 cursor-pointer"
              (click)="onOpenDialog($event, 'show-manageWriters')">
              <div class="d-flex align-items-stretch w-100">
                <div class="d-flex align-items-center p-2 me-1">
                  <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                    [fontColor]="'text-muted'"></app-icon-badge>
                </div>

                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                  <div class="d-flex flex-column p-1">
                    <app-headline [type]="'h6'" [title]="'Nature Enthusiasts'"
                      [class]="'text-muted fs-default'"></app-headline>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">General
                      Discussions</app-content>
                  </div>
                </div>

                <div class="d-flex align-items-center pe-2">
                  <app-tooltip [text]="('COMMUNITYMANAGERWRITERSTOOLTIP' | translate)" [opensOn]="'Auto'">
                    <app-form-button (click)="onOpenDialog($event, 'show-manageWriters')" [text]="''"
                      [cssClass]="'e-btn e-flat fs-default text-muted p-1'" [icon]="'person'"
                      [iconClass]="'fs-4 m-1'"></app-form-button>
                  </app-tooltip>
                </div>
              </div>
            </div>

            <div class="card topic-card d-flex align-items-center mb-2 cursor-pointer"
              (click)="onOpenDialog($event, 'show-manageWriters')">
              <div class="d-flex align-items-stretch w-100">
                <div class="d-flex align-items-center p-2 me-1">
                  <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                    [fontColor]="'text-muted'"></app-icon-badge>
                </div>

                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                  <div class="d-flex flex-column p-1">
                    <app-headline [type]="'h6'" [title]="'Culinary Explorers'"
                      [class]="'text-muted fs-default'"></app-headline>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">General
                      Discussions</app-content>
                  </div>
                </div>

                <div class="d-flex align-items-center pe-2">
                  <app-tooltip [text]="('COMMUNITYMANAGERWRITERSTOOLTIP' | translate)" [opensOn]="'Auto'">
                    <app-form-button (click)="onOpenDialog($event, 'show-manageWriters')" [text]="''"
                      [cssClass]="'e-btn e-flat fs-default text-muted p-1'" [icon]="'person'"
                      [iconClass]="'fs-4 m-1'"></app-form-button>
                  </app-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog Edit Writers List-->
    <ejs-dialog target=".dialogs" class="smallmenu-dialog" [visible]='false' #manageWriters
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('COMMUNITYWRITERSMANAGEMENTTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('COMMUNITYWRITERSMANAGEMENTHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="custom-scrollbar overflow-y-auto h-100 mb-3 p-0">
          <div class="d-flex flex-column col-12 mx-auto justify-content-center pt-4 p-3">
            <app-form-label [label]="'COMMUNITYMANAGEWRITERSFORLABEL' | translate"></app-form-label>
            <div class="row mb-3">
              <div class="col-12">
                USER GROUP WITH WRITERS
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="true"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog To Move Community Tile -->
    <ejs-dialog target=".dialogs" class="simple-dialog" [visible]='false' #relocateCommunityList
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' #showEventParticipantsDialog
      [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'"
      [height]="'60vh'" [zIndex]="999" [showCloseIcon]="true">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('COMMUNITYLISTOFCOMMUNITIESANDSUBCOMMUNITIESTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
            [text]="('COMMUNITYLISTOFCOMMUNITIESANDSUBCOMMUNITIESHELP' | translate)" [width]="'300px'"
            [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="d-flex flex-column h-100 p-3">
          <app-form-input [placeholder]="('COMMUNITYSEARCHCOMMUNITYNAME' | translate)" [iconFront]="'search'"
            [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'search_topic_name'"
            [fG]="communityForm"></app-form-input>
          <h6 class="text-center text-secondary">Community could not be found!</h6>
          <!-- SCrollable content-->
          <div class="custom-scrollbar overflow-y-auto">
            <div class="card community-relocate-card d-flex align-items-center mb-2 cursor-pointer" (click)="true">
              <div class="d-flex align-items-stretch w-100">
                <div class="d-flex align-items-center p-2 me-1">
                  <app-icon-badge [style]="'default'" [icon]="'more_horiz'" [fontSize]="'fs-3'"
                    [fontColor]="'text-muted'"></app-icon-badge>
                </div>

                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                  <div class="d-flex flex-column p-1">
                    <app-headline [type]="'h6'" [title]="'Make Top-Level Community'"
                      [class]="'text-muted fs-default'"></app-headline>
                  </div>
                </div>
              </div>
            </div>

            <div class="card community-relocate-card d-flex align-items-center mb-2 cursor-pointer" (click)="true">
              <div class="d-flex align-items-stretch w-100">
                <div class="d-flex align-items-center p-2 me-1">
                  <app-icon-badge [style]="'default'" [icon]="'forum'" [fontSize]="'fs-3'"
                    [fontColor]="'text-warning'"></app-icon-badge>
                </div>

                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                  <div class="d-flex flex-column p-1">
                    <app-headline [type]="'h6'" [title]="'Sports'" [class]="'text-muted fs-default'"></app-headline>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">Top-Level
                      Community</app-content>
                  </div>
                </div>
              </div>
            </div>

            <div class="card community-relocate-card d-flex align-items-center mb-2 cursor-pointer selected"
              (click)="onOpenDialog($event, 'show-manageWriters')">
              <div class="d-flex align-items-stretch w-100">
                <div class="d-flex align-items-center p-2 me-1">
                  <app-icon-badge [style]="'default'" [icon]="'forum'" [fontSize]="'fs-3'"
                    [fontColor]="'text-warning'"></app-icon-badge>
                </div>

                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                  <div class="d-flex flex-column p-1">
                    <app-headline [type]="'h6'" [title]="'Nature Enthusiasts'"
                      [class]="'text-muted fs-default'"></app-headline>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">Nature</app-content>
                  </div>
                </div>
              </div>
            </div>

            <div class="card community-relocate-card d-flex align-items-center mb-2 cursor-pointer"
              (click)="onOpenDialog($event, 'show-manageWriters')">
              <div class="d-flex align-items-stretch w-100">
                <div class="d-flex align-items-center p-2 me-1">
                  <app-icon-badge [style]="'default'" [icon]="'forum'" [fontSize]="'fs-3'"
                    [fontColor]="'text-warning'"></app-icon-badge>
                </div>

                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                  <div class="d-flex flex-column p-1">
                    <app-headline [type]="'h6'" [title]="'Culinary Explorers'"
                      [class]="'text-muted fs-default'"></app-headline>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">General
                      Discussions</app-content>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'COMMUNITYRELOCATETOSELECTEDBUTTON' | translate" (click)="true"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>
  </div>
</div>